/**
 * Path utility functions
 *
 * Shared utilities for path manipulation and protocol checking.
 * Use these to avoid duplication across components.
 */

import {
    isExternalPath as isExternalPathFromConfig,
    isProtocolPath as isProtocolPathFromConfig,
} from '../data/static/locale-config.js'

/**
 * Check if a path is an external path (has protocol or is absolute URL)
 * @param {string} path - Path to check
 * @returns {boolean} True if path is external
 */
export function isExternalPath (path) {
    return isExternalPathFromConfig(path)
}

/**
 * Check if a path starts with a protocol (http, https, mailto, etc.)
 * @param {string} path - Path to check
 * @returns {boolean} True if path starts with a protocol
 */
export function isProtocolPath (path) {
    return isProtocolPathFromConfig(path)
}
